import { render, staticRenderFns } from "./EmailCustomer.vue?vue&type=template&id=60194283&"
import script from "./EmailCustomer.vue?vue&type=script&lang=js&"
export * from "./EmailCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports